import api from 'Application/api/api';

const getMyActiveProjectById = (signal, id) =>
	api.get(`/projects/my-active-project-by-id/${id}`, {
		signal,
	});

export default getMyActiveProjectById;
